<template>
  <div>
    <a-modal
      width="40%"
      title="驳回原因"
      destroy-on-close
      :visible.sync="visible"
      append-to-body
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-textarea placeholder="请输入驳回原因" :rows="4" v-model="reasonText" />
    </a-modal>
  </div>
</template>
  <script>
import { postAction } from "../../api";
export default {
  name: "",
  data() {
    return {
      visible: false,
      reasonText: "",
      taskIds: "",
      type: "right",
    };
  },
  methods: {
    init(taskIds, type) {
      console.log("🚀 ~ init ~ taskIds:", taskIds);
      this.visible = true;
      this.reasonText = "";
      this.taskIds = taskIds;
      this.type = type;
    },
    handleOk() {
      this.executeAudit("reject", this.taskIds, this.type);
    },
    handleCancel() {
      this.visible = false;
      this.reasonText = "";
    },
    // 执行审核操作
    async executeAudit(action, ids, type = "right") {
      try {
        let endpoint, params;

        if (type === "left") {
          // 左侧批量审核（按模块审核）
          endpoint = "/audit/lxAuditTask/batchAuditTask";
          params = {
            taskTypes: ids,
            auditState: 2, // 1:通过 2:驳回
            remark: this.reasonText,
            applyId: this.$route.query.id,
          };
        } else {
          // 右侧批量审核（按具体项审核）
          endpoint = "/audit/lxAuditTask/auditTask";
          params = {
            taskIds: ids,
            auditState: 2, // 1:通过 2:驳回
            remark: this.reasonText,
          };
        }

        const res = await postAction(endpoint, params);
        if (res.code === 200) {
          this.$message.success(res.message || "驳回成功");
          this.visible = false;
          this.$emit("handleRejectSuccess", type);
        } else {
          this.$message.error(res.message || `驳回失败`);
        }
      } catch (error) {
        console.error("审核操作失败:", error);
        this.$message.error("审核操作失败");
      }
    },
  },

  mounted() {},
};
</script>
  <style scoped lang="scss">
</style>